var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.022 1C5.631 1 1 6.214 1 12C1 13.848 1.539 15.751 2.485 17.489C2.661 17.775 2.683 18.138 2.562 18.479L1.825 20.943C1.66 21.537 2.166 21.977 2.727 21.801L4.949 21.141C5.554 20.943 6.027 21.196 6.5891 21.537C8.1951 22.483 10.196 22.967 12 22.967C17.456 22.967 23 18.754 23 11.967C23 6.115 18.27 1 12.022 1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9786 13.4191C11.1976 13.4081 10.5706 12.7811 10.5706 12.0001C10.5706 11.2301 11.2086 10.5921 11.9786 10.6031C12.7596 10.6031 13.3866 11.2301 13.3866 12.0111C13.3866 12.7811 12.7596 13.4191 11.9786 13.4191ZM6.90708 13.4191C6.13708 13.4191 5.49908 12.7811 5.49908 12.0111C5.49908 11.2301 6.12608 10.6031 6.90708 10.6031C7.68808 10.6031 8.31508 11.2301 8.31508 12.0111C8.31508 12.7811 7.68808 13.4081 6.90708 13.4191ZM15.6413 12.0111C15.6413 12.7811 16.2683 13.4191 17.0493 13.4191C17.8303 13.4191 18.4573 12.7811 18.4573 12.0111C18.4573 11.2301 17.8303 10.6031 17.0493 10.6031C16.2683 10.6031 15.6413 11.2301 15.6413 12.0111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabConnect);
export default __webpack_public_path__ + "static/media/tab-connect.825af2c7a86d7afac24571574d83a60f.svg";
export { ForwardRef as ReactComponent };